import { render, staticRenderFns } from "./BirthdaysExportTable.vue?vue&type=template&id=17a5d10d&"
import script from "./BirthdaysExportTable.vue?vue&type=script&lang=js&"
export * from "./BirthdaysExportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports